import { PostgrestError } from "@supabase/supabase-js";
import { Notification } from "providers/NotifierProvider";
import { supabase } from "supabase/client";
import { Database } from "supabase/types";
import logSentryError from "utils/logSentryError";

type DbFeedback = Database["public"]["Tables"]["feedback"];
export type FeedbackRow = DbFeedback["Row"];
export type FeedbackInsert = DbFeedback["Insert"];
export type FeedbackUpdate = DbFeedback["Update"];

export interface Feedback {
  created_at: Date;
  details: string;
  id: number;
  route: string;
  uid?: string;
  user_agent: string;
  user_satisfaction: number;
}

class FeedbackApi {
  showNotification?: (notification: Notification) => void;

  constructor(showNotification?: (notification: Notification) => void) {
    this.showNotification = showNotification;
  }

  /**
   * Send user feedback
   *
   * @returns
   */
  async sendFeedback(feedback: Omit<FeedbackRow, "created_at" | "id">): Promise<{
    error: PostgrestError | null;
  }> {
    const { error } = await supabase.from("feedback").insert(feedback);

    if (error) {
      if (this.showNotification) {
        this.showNotification({
          message: "Unable to send feedback.",
          severity: "error",
        });
      }

      logSentryError(error, "FEEDBACK_API: sendFeedback");
      return { error };
    }

    return { error: null };
  }
}

export default FeedbackApi;
